module.exports = __webpack_public_path__ + "static/5-3300a5a09398c7441c0fd6d5a0424de6.jpg";